import Select, {OnChangeValue} from 'react-select';
import {useAsyncResource} from 'use-async-resource';
import {User} from '../models/table-models';
import {useTranslation} from 'react-i18next';
import {FilterMultiSelectProps} from './LogsMultiSelect';
import {useGetUsers} from '../utils/users-hooks';
import {useContext, useEffect} from "react";
import {AuthContext} from "../context/AuthContext";

export const DistributorSelectFilter = ({filter, setFilter}: FilterMultiSelectProps) => {
    const {t} = useTranslation('translation', {keyPrefix: 'common'});
    const {loggedUser, group, hasPermission} = useContext(AuthContext);
    const [getDistributors] = useAsyncResource(useGetUsers,
        group.mainGroup !== undefined
            ? { filter: { tags: [], search: group.mainGroup + '-' + group.subGroup } }
            : undefined, 'DISTRIBUTOR,INSTALLER');
    const {items} = getDistributors();
    const onChange = (user: OnChangeValue<User, false>) => {
        const id = user?.id ? String(user?.id) : undefined;
        setFilter({...filter, id});
    };

    useEffect(() => {
        setFilter({
            ...filter, id:
                items.find((item) => item.id == loggedUser?.id && !hasPermission(["ADMIN","COORDINATOR"]))?.id ? String(items.find((item) => item.id == loggedUser?.id)?.id) : undefined
        });
    }, []);

    return (
        items.find((item) => item.id == loggedUser?.id && !hasPermission(["ADMIN","COORDINATOR"]))?.id ? <></> :
            <Select
                className='logs-select'
                placeholder={t('distributor')}
                name='colors'
                isClearable
                options={items}
                getOptionLabel={({name}) => name}
                getOptionValue={({username}) => username}
                onChange={(newValue) => onChange(newValue)}
                backspaceRemovesValue
            />
    );
};
